"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _path;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.6L6.215 9.815 7.629 8.4 12 12.771l4.372-4.37 1.414 1.414L12 15.6z"
  }))];
};

exports.default = _default;